import { Typography } from "@mui/material"
import type { FC } from "react"

import { pluralize } from "../../../../utils/stringUtils"

interface CustomerOrderSalesOrderCountCellProps {
  count: number
  testId?: string
}

export const CustomerOrderSalesOrderCountCell: FC<CustomerOrderSalesOrderCountCellProps> = ({ count, testId }) => {
  const label = `${count} ${pluralize(count, "Order", "Orders")}`
  const isPopulated = count > 0

  return (
    <Typography
      component='span'
      variant='body2'
      data-testid={testId}
      className={isPopulated ? "font-bold text-primary" : "text-gray-700"}
    >
      {label}
    </Typography>
  )
}
